export default class RouteSegment {
  /**
   * @param {Object} data
   * @param {RouteResponsePoint} data.routePoint
   * @param {RouteDetails} data.routeDetails
   */
  constructor({ routePoint, routeDetails }) {
    /** @type {RouteResponsePoint} */
    this.routePoint = routePoint;
    /** @type {RouteDetails} */
    this.routeDetails = routeDetails;
  }
}